// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IOfferFeatures } from '../offer_features/OfferFeatures';
import type { IGeoForMobileSite } from '../geo_for_mobile_site/GeoForMobileSite';
import type { IMedia } from '../media/Media';
import type { IOfferInfo } from '../offer_info/OfferInfo';
import type { IPhotoLabel } from '../photo_label/PhotoLabel';
import type { IPriceForMobileSite } from '../price_for_mobile_site/PriceForMobileSite';
import type { IPuids } from '../puids/Puids';
import type { IAuthor } from '../author/Author';
import type { IBuildingForMobileSite } from '../building_for_mobile_site/BuildingForMobileSite';
import type { IGroupedOffers } from '../grouped_offers/GroupedOffers';
import type { IIdenticalOffers } from '../identical_offers/IdenticalOffers';
import type { IInfiniteSearchResult } from '../infinite_search_result/InfiniteSearchResult';
import type { IModerationInfo } from '../moderation_info/ModerationInfo';
import type { INewbuildingDynamicCalltracking } from '../newbuilding_dynamic_calltracking/NewbuildingDynamicCalltracking';
import type { IPessimization } from '../pessimization/Pessimization';
import type { IPhotoFeatureIcon } from '../photo_feature_icon/PhotoFeatureIcon';
import type { IPromoSuburban } from '../promo_suburban/PromoSuburban';
import type { IVillageForMobileSite } from '../village_for_mobile_site/VillageForMobileSite';
import type { IVillageAdvantage } from '../village_advantage/VillageAdvantage';
import type { IDiscount } from '../discount/Discount';

export interface IDailyRentOfferForMobileSite {
  /** Категория объявления **/
  category: ECategory;
  /** Cian ID объявления **/
  cianId: number;
  /** Название партнера, если объявление партнерское **/
  cianPartnerName?: TDailyRentOfferForMobileSite_CianPartnerName;
  /** Тип сделки **/
  dealType: EDealType;
  /** Описание объявления **/
  description: string;
  features: IOfferFeatures;
  /** Строка для передачи в аналитику при расхлопе **/
  gaLabel: string;
  geo: IGeoForMobileSite;
  /** Список иконок VAS'ов **/
  icons: EIcons[];
  /** Realty ID объявления **/
  id: number;
  /** У объявления подключена опция Выделения Цветом **/
  isColorized: boolean;
  /** Объявление в избранном у пользователя **/
  isFavorite: boolean;
  /** У объявления подключена опция ТОП **/
  isPromoted: boolean;
  /** Список фото **/
  media: IMedia[];
  offerInfo: IOfferInfo;
  /** Тип объявления **/
  offerType: EOfferType;
  /** Список телефонов объявления в формате +74959998877 **/
  phones: string[];
  /** Лейблы на фото **/
  photoLabels: IPhotoLabel[];
  price: IPriceForMobileSite;
  puids: IPuids;
  /** Возможно ли забронировать онлайн через ЦИАН **/
  isOnlineBooking: boolean;
  /** Показывать ли календарь бронирования **/
  showBookingCalendar: boolean;
  /** Показатель является ли объявлением отелем **/
  isHotel: boolean;
  /** Тип действия при нажатии на кнопку **/
  actionType: EActionType;
  /** Текст сообщения для чата при бронировании онлайн **/
  onlineBookingMessage?: TDailyRentOfferForMobileSite_OnlineBookingMessage;
  /** Цена за квадратный метр **/
  additionalPrice?: TDailyRentOfferForMobileSite_AdditionalPrice;
  /** Признаки объявлений (ЭТП, Залоговая, Аукцион) **/
  agentLists?: TDailyRentOfferForMobileSite_AgentLists;
  /** Автор объявления **/
  author?: TDailyRentOfferForMobileSite_Author;
  /** Уровень брендинга **/
  brandingLevel?: TDailyRentOfferForMobileSite_BrandingLevel;
  /** Информация о корпусе новостройки/ЖК **/
  building?: TDailyRentOfferForMobileSite_Building;
  /** Объявление свободно на даты, можно забронировать **/
  canBeBooked?: TDailyRentOfferForMobileSite_CanBeBooked;
  /** Версия cделки в аренде **/
  dealRentMonetization?: TDailyRentOfferForMobileSite_DealRentMonetization;
  /** Версия cделки в аренде **/
  dealRentVersion?: TDailyRentOfferForMobileSite_DealRentVersion;
  /** Ссылка на объявление на сайте партнера **/
  externalOfferUrl?: TDailyRentOfferForMobileSite_ExternalOfferUrl;
  /** Объявление создано с помощью импорта **/
  fromImport?: TDailyRentOfferForMobileSite_FromImport;
  /** Еще такие же квартиры в этом доме **/
  groupedOffers?: TDailyRentOfferForMobileSite_GroupedOffers;
  /** Признак наличия 3д тура **/
  hasTour?: TDailyRentOfferForMobileSite_HasTour;
  /** Информация о дубликатах **/
  identicalOffers?: TDailyRentOfferForMobileSite_IdenticalOffers;
  /** Подключен ли колтрекинг **/
  isCalltrackingEnabled?: TDailyRentOfferForMobileSite_IsCalltrackingEnabled;
  /** Объявление от партнера Циан **/
  isCianPartner?: TDailyRentOfferForMobileSite_IsCianPartner;
  /** Проверен ли хотя бы один кадастровый номер объявления в росреестре **/
  isRosreestrChecked?: TDailyRentOfferForMobileSite_IsRosreestrChecked;
  /** Флаг "просмотренности" объявления **/
  isViewedOffer?: TDailyRentOfferForMobileSite_IsViewedOffer;
  /** Данные бесконечного поиска необходимые для отчетных событий **/
  mlSuggestionsInfiniteSearchResult?: TDailyRentOfferForMobileSite_MlSuggestionsInfiniteSearchResult;
  /** Данные об отображении объявления от модерации **/
  moderationInfo?: TDailyRentOfferForMobileSite_ModerationInfo;
  /** Данные для динамического коллтрекинга новостроек **/
  newbuildingDynamicCalltracking?: TDailyRentOfferForMobileSite_NewbuildingDynamicCalltracking;
  /** Id ЖК **/
  newbuildingId?: TDailyRentOfferForMobileSite_NewbuildingId;
  /** Сделка в аренде **/
  offerInDeal?: TDailyRentOfferForMobileSite_OfferInDeal;
  /** Пессимизация **/
  pessimization?: TDailyRentOfferForMobileSite_Pessimization;
  /** Иконки фичей объявления(наличие 3д-тура, записи на просмотр и тд.) **/
  photoFeatureIcons?: TDailyRentOfferForMobileSite_PhotoFeatureIcons;
  /** Лейбл на фото. Устаревшее, см. photo_labels **/
  photoLabel?: TDailyRentOfferForMobileSite_PhotoLabel;
  /** Акции для загородки **/
  promoSuburban?: TDailyRentOfferForMobileSite_PromoSuburban;
  /** Показывать ли предупреждение о недопустимости предоплаты **/
  showWarningMessage?: TDailyRentOfferForMobileSite_ShowWarningMessage;
  /** VAS заголовок **/
  vasTitle?: TDailyRentOfferForMobileSite_VasTitle;
  /** Информация о КП **/
  village?: TDailyRentOfferForMobileSite_Village;
  /** Преимущества КП **/
  villageAdvantages?: TDailyRentOfferForMobileSite_VillageAdvantages;
  /** Доступна ли по объявлению сельская ипотека **/
  villageMortgageAllowed?: TDailyRentOfferForMobileSite_VillageMortgageAllowed;
  /** Кол-во отзывов **/
  reviewsCount?: TDailyRentOfferForMobileSite_ReviewsCount;
  /** Оценка объекта **/
  rating?: TDailyRentOfferForMobileSite_Rating;
  /** Информер под ценой **/
  priceSubtitle?: TDailyRentOfferForMobileSite_PriceSubtitle;
  /** Кол-во звезд у отеля **/
  starRating?: TDailyRentOfferForMobileSite_StarRating;
  /** Скидка **/
  discount?: TDailyRentOfferForMobileSite_Discount;
  /** Уровень продвижения и ставка **/
  promotionDescription?: string;
}

export enum ECategory {
  /** Аренда койко-места **/
  'BedRent' = 'bedRent',
  /** Аренда здания **/
  'BuildingRent' = 'buildingRent',
  /** Продажа здания **/
  'BuildingSale' = 'buildingSale',
  /** Аренда готового бизнеса **/
  'BusinessRent' = 'businessRent',
  /** Продажа готового бизнеса **/
  'BusinessSale' = 'businessSale',
  /** Аренда автосервис **/
  'CarServiceRent' = 'carServiceRent',
  /** Продажа автосервиса **/
  'CarServiceSale' = 'carServiceSale',
  /** Аренда коммерческой земли **/
  'CommercialLandRent' = 'commercialLandRent',
  /** Продажа коммерческой земли **/
  'CommercialLandSale' = 'commercialLandSale',
  /** Аренда коттеджа **/
  'CottageRent' = 'cottageRent',
  /** Продажа коттеджа **/
  'CottageSale' = 'cottageSale',
  /** Посуточная аренда койко-места **/
  'DailyBedRent' = 'dailyBedRent',
  /** Посуточная аренда квартиры **/
  'DailyFlatRent' = 'dailyFlatRent',
  /** Посуточная аренда дома, дачи, коттеджа **/
  'DailyHouseRent' = 'dailyHouseRent',
  /** Посуточная аренда комнаты **/
  'DailyRoomRent' = 'dailyRoomRent',
  /** Аренда помещения под бытовые услуги **/
  'DomesticServicesRent' = 'domesticServicesRent',
  /** Продажа помещения под бытовые услуги **/
  'DomesticServicesSale' = 'domesticServicesSale',
  /** Аренда квартиры **/
  'FlatRent' = 'flatRent',
  /** Продажа квартиры **/
  'FlatSale' = 'flatSale',
  /** Продажа доли в квартире **/
  'FlatShareSale' = 'flatShareSale',
  /** Аренда помещения свободного назначения **/
  'FreeAppointmentObjectRent' = 'freeAppointmentObjectRent',
  /** Продажа помещения свободного назначения **/
  'FreeAppointmentObjectSale' = 'freeAppointmentObjectSale',
  /** Аренда гаража **/
  'GarageRent' = 'garageRent',
  /** Продажа гаража **/
  'GarageSale' = 'garageSale',
  /** Аренда дома/дачи **/
  'HouseRent' = 'houseRent',
  /** Продажа дома/дачи **/
  'HouseSale' = 'houseSale',
  /** Аренда части дома **/
  'HouseShareRent' = 'houseShareRent',
  /** Продажа части дома **/
  'HouseShareSale' = 'houseShareSale',
  /** Аренда производства **/
  'IndustryRent' = 'industryRent',
  /** Продажа производство **/
  'IndustrySale' = 'industrySale',
  /** Продажа участка **/
  'LandSale' = 'landSale',
  /** Продажа квартиры в новостройке **/
  'NewBuildingFlatSale' = 'newBuildingFlatSale',
  /** Аренда офиса **/
  'OfficeRent' = 'officeRent',
  /** Продажа офиса **/
  'OfficeSale' = 'officeSale',
  /** Аренда общепита **/
  'PublicCateringRent' = 'publicCateringRent',
  /** Продажа общепита **/
  'PublicCateringSale' = 'publicCateringSale',
  /** Аренда комнаты **/
  'RoomRent' = 'roomRent',
  /** Продажа комнаты **/
  'RoomSale' = 'roomSale',
  /** Аренда торговой площади **/
  'ShoppingAreaRent' = 'shoppingAreaRent',
  /** Продажа торговой площади **/
  'ShoppingAreaSale' = 'shoppingAreaSale',
  /** Аренда таунхауса **/
  'TownhouseRent' = 'townhouseRent',
  /** Продажа таунхауса **/
  'TownhouseSale' = 'townhouseSale',
  /** Аренда склада **/
  'WarehouseRent' = 'warehouseRent',
  /** Продажа склада **/
  'WarehouseSale' = 'warehouseSale',
}
export type TDailyRentOfferForMobileSite_CianPartnerName = null | string;

export enum EDealType {
  /** Аренда **/
  'Rent' = 'rent',
  /** Продажа **/
  'Sale' = 'sale',
}
export enum EIcons {
  /** Аукцион **/
  'Auction' = 'auction',
  /** От застройщика **/
  'Builder' = 'builder',
  /** Выделение цветом **/
  'Colorized' = 'colorized',
  /** Честная игра **/
  'FairPlay' = 'fairPlay',
  /** Платное **/
  'Payed' = 'payed',
  /** Премиум **/
  'Premium' = 'premium',
  /** Объявление разместил профи **/
  'Pro' = 'pro',
  /** Продвижение "Стандарт" **/
  'Standard' = 'standard',
  /** ТОП-3 **/
  'Top3' = 'top3',
}
export enum EOfferType {
  /** коммерческая **/
  'Commercial' = 'commercial',
  /** квартиры **/
  'Flat' = 'flat',
  /** новостройки **/
  'Newobject' = 'newobject',
  /** загородка **/
  'Suburban' = 'suburban',
}
export enum EActionType {
  /** Бронирование **/
  'OtaBooking' = 'otaBooking',
  /** Проверка дат **/
  'OtaCheckDates' = 'otaCheckDates',
  /** Возможность связаться напрямую **/
  'Contact' = 'contact',
  /** Возможность написать в чат **/
  'Chat' = 'chat',
  /** Забронировать партнёрский объект **/
  'PartnerBooking' = 'partnerBooking',
  /** Проверка дат у партнёрского объекта **/
  'PartnerCheckDates' = 'partnerCheckDates',
  /** Смотреть заявку на бронирование **/
  'BookingRequestView' = 'bookingRequestView',
}
export type TDailyRentOfferForMobileSite_OnlineBookingMessage = null | string;

export type TDailyRentOfferForMobileSite_AdditionalPrice = null | string;

export type TDailyRentOfferForMobileSite_AgentLists = null | string[];

export type TDailyRentOfferForMobileSite_Author = null | IAuthor;

export type TDailyRentOfferForMobileSite_BrandingLevel = null | EBrandingLevel;

export enum EBrandingLevel {
  'FirstLevel' = 'firstLevel',
  'SecondLevel' = 'secondLevel',
  'ThirdLevel' = 'thirdLevel',
}
export type TDailyRentOfferForMobileSite_Building = null | IBuildingForMobileSite;

export type TDailyRentOfferForMobileSite_CanBeBooked = null | boolean;

export type TDailyRentOfferForMobileSite_DealRentMonetization = null | EDealRentMonetization;

export enum EDealRentMonetization {
  /** Комиссию платит собственник **/
  'FeeByHomeowner' = 'feeByHomeowner',
  /** Комиссию платит арендатор **/
  'FeeByRenter' = 'feeByRenter',
  /** Комиссия включена в цену объявления **/
  'FeeIncludedInOfferPrice' = 'feeIncludedInOfferPrice',
}
export type TDailyRentOfferForMobileSite_DealRentVersion = null | EDealRentVersion;

export enum EDealRentVersion {
  'V1' = 'v1',
  'V2' = 'v2',
}
export type TDailyRentOfferForMobileSite_ExternalOfferUrl = null | string;

export type TDailyRentOfferForMobileSite_FromImport = null | boolean;

export type TDailyRentOfferForMobileSite_GroupedOffers = null | IGroupedOffers;

export type TDailyRentOfferForMobileSite_HasTour = null | boolean;

export type TDailyRentOfferForMobileSite_IdenticalOffers = null | IIdenticalOffers;

export type TDailyRentOfferForMobileSite_IsCalltrackingEnabled = null | boolean;

export type TDailyRentOfferForMobileSite_IsCianPartner = null | boolean;

export type TDailyRentOfferForMobileSite_IsRosreestrChecked = null | boolean;

export type TDailyRentOfferForMobileSite_IsViewedOffer = null | boolean;

export type TDailyRentOfferForMobileSite_MlSuggestionsInfiniteSearchResult = null | IInfiniteSearchResult;

export type TDailyRentOfferForMobileSite_ModerationInfo = null | IModerationInfo;

export type TDailyRentOfferForMobileSite_NewbuildingDynamicCalltracking = null | INewbuildingDynamicCalltracking;

export type TDailyRentOfferForMobileSite_NewbuildingId = null | number;

export type TDailyRentOfferForMobileSite_OfferInDeal = null | boolean;

export type TDailyRentOfferForMobileSite_Pessimization = null | IPessimization;

export type TDailyRentOfferForMobileSite_PhotoFeatureIcons = null | TDailyRentOfferForMobileSite_PhotoFeatureIcons_1;

export type TDailyRentOfferForMobileSite_PhotoFeatureIcons_1 = IPhotoFeatureIcon[];

export type TDailyRentOfferForMobileSite_PhotoLabel = null | IPhotoLabel;

export type TDailyRentOfferForMobileSite_PromoSuburban = null | TDailyRentOfferForMobileSite_PromoSuburban_1;

export type TDailyRentOfferForMobileSite_PromoSuburban_1 = IPromoSuburban[];

export type TDailyRentOfferForMobileSite_ShowWarningMessage = null | boolean;

export type TDailyRentOfferForMobileSite_VasTitle = null | string;

export type TDailyRentOfferForMobileSite_Village = null | IVillageForMobileSite;

export type TDailyRentOfferForMobileSite_VillageAdvantages = null | TDailyRentOfferForMobileSite_VillageAdvantages_1;

export type TDailyRentOfferForMobileSite_VillageAdvantages_1 = IVillageAdvantage[];

export type TDailyRentOfferForMobileSite_VillageMortgageAllowed = null | boolean;

export type TDailyRentOfferForMobileSite_ReviewsCount = null | string;

export type TDailyRentOfferForMobileSite_Rating = null | string;

export type TDailyRentOfferForMobileSite_PriceSubtitle = null | string;

export type TDailyRentOfferForMobileSite_StarRating = null | string;

export type TDailyRentOfferForMobileSite_Discount = null | IDiscount;
